module.exports = __webpack_public_path__ + "img/btn_auto_spin.48cd9c51.png";